<template>
  <div class="footer">
    <!--
    <p><a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2024122749号</a>      京公网安备: 11040102100209号       山东宇航学会 版权所有 </p>
    -->
    <p><a href="https://beian.miit.gov.cn/" style="color: #d7d7d7;" target="_blank">鲁ICP备2024122749号</a>       山东宇航学会 版权所有 </p>
  </div>
</template>

<script>
export default {
  name: "FooterVue",
};
</script>

<style lang="less" scoped >
.footer {
  height: 100%;
  background-color: #0F3675;
  text-align: center;
  // color: #fff;
  color: #D7D7D7;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    margin-top: 5px;
  }
}
</style>